import { useSelector } from "react-redux";
import HtmlContent from "./HtmlContent";

// Keys correspond to window.__APP_HTML entries populated by
// /public/content/pancyrillic_help_<lang>.js.
const CONTENT_KEYS = {
    ru: 'pancyrillic_help_ru',
    en: 'pancyrillic_help_en',
};

const PanCyrillicHelp = () => {
    const rus = useSelector(state => state.rus);
    const lang = rus ? 'ru' : 'en';

    return <HtmlContent contentKey={CONTENT_KEYS[lang]} />;
};

export default PanCyrillicHelp;
